import React, { useRef, useEffect } from "react";

interface ShadowContentProps {
  htmlContent: string; // El contenido HTML que se inyectará en el Shadow DOM
}

const ShadowContent: React.FC<ShadowContentProps> = ({ htmlContent }) => {

  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (containerRef.current) {
      // Verificar si el Shadow Root ya existe
      if (!containerRef.current.shadowRoot) {
        const shadowRoot = containerRef.current.attachShadow({ mode: "open" });
        shadowRoot.innerHTML = `
          <style>
            /* Puedes añadir estilos personalizados aquí si es necesario */
          </style>
          ${htmlContent}
        `;
      } else {
        // Actualizar el contenido si el Shadow Root ya existe
        const shadowRoot = containerRef.current.shadowRoot;
        if (shadowRoot) {
          shadowRoot.innerHTML = `
            <style>
              /* Puedes añadir estilos personalizados aquí si es necesario */
            </style>
            ${htmlContent}
          `;
        }
      }
    }
  }, [htmlContent]);
  return <div ref={containerRef}></div>;
};

export default ShadowContent;
